// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fPtumn {
  display: flex;
  height: 100%;
  overflow: hidden;
  padding: var(--spacing-3) 0;
}

.UKFEBR {
  align-items: start;
  flex: 1;
  padding: 0 var(--spacing-3);
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
}

.pk_PoY {
  width: var(--spacing-4);
  height: var(--spacing-4);
  border-radius: 50%;
  background: var(--surface-neutral-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
}

.YEdBm_ {
  width: var(--spacing-2);
  height: var(--spacing-2);
}

.dqmYrd {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.MLdfmK {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: 32px;
  color: var(--text-neutral-dark);
  margin: 0;
}

.Q_wRga,
.fHp0Rc,
.oHthsi {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  color: #000;
  margin: 0;
}

.Ztw71f {
  background: var(--stroke-neutral-subtle);
  height: 100%;
  width: 1px;
}

/* Responsive design */
@media (max-width: 768px) {
  .fPtumn {
    flex-direction: column;
  }

  .Ztw71f {
    width: 100%;
    height: 1px;
    margin: 0;
  }

  .UKFEBR {
    padding: var(--spacing-3);
  }

  .k0tNEo {
    gap: var(--spacing-1-5);
  }

  .pk_PoY {
    width: var(--spacing-5);
    height: var(--spacing-5);
  }

  .mL1Z3_ {
    width: var(--spacing-3);
    height: var(--spacing-3);
  }

  .a_1Xtq {
    font-size: var(--font-size-sm);
  }

  .Q_wRga,
  .Es67pa,
  .HiOIjt {
    font-size: var(--font-size-xs);
  }
}

@media (max-width: 480px) {
  .UKFEBR {
    padding: var(--spacing-2);
  }

  .k0tNEo {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1);
  }

  .pk_PoY {
    width: var(--spacing-4);
    height: var(--spacing-4);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/CardTrackingPage/components/TrackingInfo/TrackingInfo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;;IAGE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF","sourcesContent":[".trackingInfo {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: var(--spacing-3) 0;\n}\n\n.infoSection {\n  align-items: start;\n  flex: 1;\n  padding: 0 var(--spacing-3);\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n}\n\n.iconContainer {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  border-radius: 50%;\n  background: var(--surface-neutral-subtle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: 32px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.addressText,\n.email,\n.name {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  color: #000;\n  margin: 0;\n}\n\n.separator {\n  background: var(--stroke-neutral-subtle);\n  height: 100%;\n  width: 1px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .trackingInfo {\n    flex-direction: column;\n  }\n\n  .separator {\n    width: 100%;\n    height: 1px;\n    margin: 0;\n  }\n\n  .infoSection {\n    padding: var(--spacing-3);\n  }\n\n  .sectionHeader {\n    gap: var(--spacing-1-5);\n  }\n\n  .iconContainer {\n    width: var(--spacing-5);\n    height: var(--spacing-5);\n  }\n\n  .sectionIcon {\n    width: var(--spacing-3);\n    height: var(--spacing-3);\n  }\n\n  .sectionTitle {\n    font-size: var(--font-size-sm);\n  }\n\n  .addressText,\n  .contactName,\n  .contactEmail {\n    font-size: var(--font-size-xs);\n  }\n}\n\n@media (max-width: 480px) {\n  .infoSection {\n    padding: var(--spacing-2);\n  }\n\n  .sectionHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1);\n  }\n\n  .iconContainer {\n    width: var(--spacing-4);\n    height: var(--spacing-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trackingInfo": `fPtumn`,
	"infoSection": `UKFEBR`,
	"iconContainer": `pk_PoY`,
	"icon": `YEdBm_`,
	"content": `dqmYrd`,
	"title": `MLdfmK`,
	"addressText": `Q_wRga`,
	"email": `fHp0Rc`,
	"name": `oHthsi`,
	"separator": `Ztw71f`,
	"sectionHeader": `k0tNEo`,
	"sectionIcon": `mL1Z3_`,
	"sectionTitle": `a_1Xtq`,
	"contactName": `Es67pa`,
	"contactEmail": `HiOIjt`
};
module.exports = ___CSS_LOADER_EXPORT___;
